import { computed, signal } from "@preact/signals-react"


export const acriss = signal([])
export const acrissGroups = signal([])
export const categories = signal([])
export const fuelPolicy = signal(null)
export const insurance = signal(null)
export const inTerminal = signal(null)
export const mileage = signal(null)
export const reports = signal(null)
export const offices = signal(null)
export const officesPickoff = signal(null)
export const checkReportsOffices = computed(() => !(reports.value && offices.value))
export const reportsInfo = signal([])
export const officesOptions = signal([])
export const prepaid = signal(null)
export const excludeProviders = signal(false)
export const mainProvider = signal(null)
export const providers = signal([])
export const providersList = signal([])
export const providersbyTiers = signal([])
export const mainSite = signal(null)
export const sites = signal([])
export const sitesName = signal([])
export const tiers = signal(null)
export const transmission = signal(null)
export const currency = signal(null)
export const currencyCode = signal(null)
export const excludeWebSuppliers = signal(false)
export const webSuppliers = signal([])
export const loadingDate = signal(false)
export const searchID = signal(null)
// A repricing pass opened in DOR / LOR (CU-869fmm944): its `execution_id`. Never in `reports`: the five other
// analyzers read `reports` and must never send an `rp-…` id.
export const repricingPass = signal(null)
export const repricingPassesInfo = signal([])
// whether each list of the Execution field has answered: a linked id is "not found" only once its list is known
export const repricingPassesLoaded = signal(false)
export const reportsLoaded = signal(false)
// bumped by "Refresh" on a running pass: the Execution field reloads its list
export const repricingPassesReload = signal(0)
export const isPreviousComparison = signal(false)
export const yearlyComp = signal(false)
export const timeToCompare = signal('')
export const howToGroup = signal(null)
export const companyUsers = signal([])
export const officesSharedOptions = signal([])
export const markets = signal([])
export const isOfficeGroup = signal(false)
export const officeGroup = signal(null)
export const isSiteGroup = signal(false)
export const siteGroup = signal(null)